import { render, staticRenderFns } from "./PainelPublico.vue?vue&type=template&id=24465a50&scoped=true"
import script from "./PainelPublico.vue?vue&type=script&lang=js"
export * from "./PainelPublico.vue?vue&type=script&lang=js"
import style0 from "./PainelPublico.vue?vue&type=style&index=0&id=24465a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24465a50",
  null
  
)

export default component.exports